import { Pagination, styled } from '@mui/material';
import { useEffect, useState } from 'react';

const StyledReversePagination = styled(Pagination)(({ theme }) => ({
  '& .MuiPaginationItem-page.Mui-selected': {
    fontWeight: 600,
  },
  // reverse direction
  '& .MuiPagination-ul': {
    flexDirection: 'row-reverse',
  },
  '& .MuiPaginationItem-icon': {
    transform: 'rotate(180deg)',
  },
}));

const ReversePagination = ({
  totalItems = 150,
  currentPage: externalCurrentPage,
  onPageChange,
  ...props
}) => {
  const [internalCurrentPage, setInternalCurrentPage] = useState(totalItems);

  // Use external currentPage if provided, otherwise use internal state
  const currentPage =
    externalCurrentPage !== undefined
      ? externalCurrentPage
      : internalCurrentPage;

  // Update internal state when external currentPage changes
  useEffect(() => {
    if (externalCurrentPage !== undefined) {
      setInternalCurrentPage(externalCurrentPage);
    }
  }, [externalCurrentPage]);

  const handleChange = (event, value) => {
    if (onPageChange) {
      onPageChange(value);
    } else {
      setInternalCurrentPage(value);
    }
  };

  return (
    <StyledReversePagination
      count={totalItems}
      page={currentPage}
      onChange={handleChange}
      {...props}
    />
  );
};

export default ReversePagination;
